import React, { useContext } from "react";
import type { FC } from "react";

import { VibeContext } from "../../Vibe";
import { SUBTITLE_SIZE_BY_VIBE_CONTEXT } from "../../constants/sizes";
import VibeTextCore from "../../helper/VibeTextCore";

import type { VibeTextCoreProps } from "../../helper/VibeTextCore";

const VIBE_SUBTITLE_TEST_ID = "vibe-subtitle-test-id";

export const VibeSubtitle: FC<VibeTextCoreProps> = (props) => {
    const { context } = useContext(VibeContext);

    const textProps: VibeTextCoreProps = (() => {
        if (context !== "custom") {
            return {
                ...props,
                size: SUBTITLE_SIZE_BY_VIBE_CONTEXT[context],
            } as VibeTextCoreProps;
        }

        return props;
    })();

    return (
        <VibeTextCore
            view="secondary"
            data-tsid={VIBE_SUBTITLE_TEST_ID}
            {...textProps}
        />
    );
};

VibeSubtitle.displayName = "Vibe.Subtitle";

export default VibeSubtitle;
